import React, {useState} from 'react'
import { Nav, NavLink, Bars, NavMenu, NavBtn, NavBtnLink, NavLogo, Portfolio } from './NavbarElements'
import { Link } from 'react-router-dom'
import * as AiIcons from 'react-icons/ai'
import * as RiIcons from 'react-icons/ri'
import * as BsIcons from 'react-icons/bs'
import * as FaIcons from 'react-icons/fa'
import './Navbar.css'
import { IconContext } from 'react-icons'
import { ProSidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import 'react-pro-sidebar/dist/css/styles.css';


function Navbar() {

    const [sidebar, setSidebar] = useState(true)

    const 
    showSidebar = () => setSidebar(!sidebar)

    const sideBarItems = [

        {
            title: 'Home',
            path: '/home',
            cname: 'nav-text',
            icon: <RiIcons.RiHomeLine />
        },
        {
            title: 'Skills',
            path: '/skills',
            cname: 'nav-text',
            icon: <BsIcons.BsFillPeopleFill/>
        },
        {
            title: 'Portfolio',
            path: '/portfolio',
            cname: 'nav-text',
            icon: <BsIcons.BsFillPersonFill/>
        },
        {
            title: 'Contact',
            path: '/contact',
            cname: 'nav-text',
            icon: <AiIcons.AiFillSetting/>
        },
    ]
    return (
        <>
            <Nav>
                
                <NavMenu>
                    <NavLink to="/" activeStyle>
                        <div style={{display: 'flex', flexDirection: 'column',justifyContent: 'center', alignItems: 'center', paddingTop: '15px'}}>
                            <AiIcons.AiFillHome size ={24}/>
                            <p>Home</p>
                        </div>
                    </NavLink>
                    <NavLink to="/skills" activeStyle>
                        <div style={{display: 'flex', flexDirection: 'column',justifyContent: 'center', alignItems: 'center', paddingTop: '15px'}}>
                            <FaIcons.FaFileCode size ={24}/>
                            <p>Skills</p>
                        </div>
                    </NavLink>
                    <NavLink to="/portfolio" activeStyle>
                        <div style={{display: 'flex', flexDirection: 'column',justifyContent: 'center', alignItems: 'center', paddingTop: '15px'}}>
                            <AiIcons.AiFillFolder size ={24}/>
                            <p>Portfolio</p>
                        </div>
                    </NavLink> 
                    <NavLink to="/contact" activeStyle>
                        <div style={{display: 'flex', flexDirection: 'column',justifyContent: 'center', alignItems: 'center', paddingTop: '15px'}}>
                                <RiIcons.RiSendPlaneFill size ={24}/>
                                <p>Contact</p>
                            </div>
                    </NavLink>
                </NavMenu>
                
            </Nav>

        </>
    )
}

export default Navbar
